import { AbsoluteFill, useCurrentFrame } from "remotion";
import { activeLines, type ScriptLine } from "./script";
import { COLORS, FONTS } from "./theme";
import type { AccentName } from "./theme";

/**
 * Kinetic lower-third caption == the spoken VO line. Renders the active line(s)
 * for the scene-local frame. Solid dark bar with an accent underline (no glass);
 * sits above the bottom safe-zone for mobile + YouTube chrome.
 */
export const Caption: React.FC<{
  lines: ScriptLine[];
  accent?: AccentName;
  fps?: number;
}> = ({ lines, accent = "cyan", fps = 30 }) => {
  const frame = useCurrentFrame();
  const active = activeLines(lines, frame, fps);
  if (active.length === 0) return null;
  return (
    <AbsoluteFill
      style={{
        justifyContent: "flex-end",
        alignItems: "center",
        paddingBottom: 84,
        pointerEvents: "none",
      }}
    >
      <div
        style={{
          maxWidth: 1500,
          textAlign: "center",
          color: COLORS.text,
          fontFamily: FONTS.body,
          fontWeight: 500,
          fontSize: 38,
          lineHeight: 1.35,
          background: "rgba(11,13,18,0.80)",
          padding: "16px 30px",
          borderRadius: 12,
          border: `1px solid ${COLORS.line}`,
          borderBottom: `3px solid ${COLORS[accent]}`,
        }}
      >
        {active.map((l, i) => (
          <div key={i}>{l.caption}</div>
        ))}
      </div>
    </AbsoluteFill>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
